import { ShopRendererApiClient } from '@fourthwall/services/dist/ShopRendererApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export type SocialImageTypeParams = Parameters<
  typeof ShopRendererApiClient.updateShop
>[1]['shop']['ogImage']['type']

export const useUpdateShopRendererMutation = createMutationHook(ShopRendererApiClient.updateShop, {
  mutationKey: ['updateShopRenderer'],
})
